import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "pickupTruck"
const PickupTruckIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M15.004 8.813C16.362 8.813 17.624 9.513 18.344 10.663L19.083 11.85 21.164 12.11C21.819 12.192 22.313 12.75 22.313 13.412V16.125C22.313 16.85 21.725 17.438 21 17.438H19.523C19.069 18.222 18.22 18.75 17.25 18.75S15.431 18.222 14.977 17.438H8.647C8.195 18.222 7.348 18.75 6.376 18.75 5.212 18.75 4.225 17.993 3.881 16.945L2.801 16.779C2.16 16.68 1.687 16.13 1.687 15.481V12.75C1.688 12.025 2.276 11.438 3 11.438H9.563V8.812zM6.375 15C5.754 15 5.25 15.504 5.25 16.125S5.754 17.25 6.375 17.25 7.5 16.746 7.5 16.125 6.996 15 6.375 15M17.25 15C16.629 15 16.125 15.504 16.125 16.125S16.629 17.25 17.25 17.25 18.375 16.746 18.375 16.125 17.871 15 17.25 15M10.688 16.313H14.633Q14.626 16.22 14.625 16.125C14.625 14.675 15.8 13.5 17.25 13.5S19.875 14.675 19.875 16.125Q19.874 16.219 19.867 16.313H21C21.104 16.313 21.188 16.229 21.188 16.125V15.188H21C20.69 15.188 20.438 14.936 20.438 14.625S20.689 14.063 21 14.063H21.188V13.413C21.188 13.317 21.118 13.237 21.023 13.225L18.716 12.937H13.875C12.735 12.938 11.813 12.015 11.813 10.876V9.938H10.687zM3 12.563C2.896 12.563 2.813 12.646 2.813 12.75V13.688H3C3.31 13.688 3.563 13.939 3.563 14.25 3.563 14.56 3.31 14.813 3 14.813H2.813V15.48C2.813 15.574 2.88 15.653 2.97 15.667L3.772 15.79C3.937 14.498 5.039 13.5 6.375 13.5 7.825 13.5 9 14.675 9 16.125Q8.999 16.219 8.992 16.313H9.562V12.563zM12.938 10.875C12.938 11.393 13.358 11.813 13.875 11.813H14.063V9.937H12.937zM15.188 11.813H17.735L17.389 11.259C16.908 10.49 16.087 10.003 15.188 9.943z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default PickupTruckIcon
